import React from 'react';

export type SortDirection = 'asc' | 'desc' | null;

export interface SortIconProps {
  column: string;
  activeColumn: string;
  direction: SortDirection;
  onChange: (col: string, direction: 'asc' | 'desc') => void;
}

const SortIcon: React.FC<SortIconProps> = ({ column, activeColumn, direction, onChange }) => {
  const isActive = activeColumn === column;

  const upColor = isActive && direction === 'asc' ? '#29ABE2' : '#b0b8c1';
  const downColor = isActive && direction === 'desc' ? '#e03131' : '#b0b8c1';

  return (
    <span
      className="ms-1"
      style={{ display: 'inline-flex', gap: '4px', verticalAlign: 'middle' }}
    >
      <i
        className="fa fa-arrow-up"
        style={{ fontSize: '13px', color: upColor, cursor: 'pointer', transition: 'color 0.2s' }}
        onClick={() => onChange(column, 'asc')}
      />
      <i
        className="fa fa-arrow-down"
        style={{ fontSize: '13px', color: downColor, cursor: 'pointer', transition: 'color 0.2s' }}
        onClick={() => onChange(column, 'desc')}
      />
    </span>
  );
};

export default SortIcon;